import Immutable from 'immutable';

export const GET_PRODUCTS = 'takeback/api/PRODUCTS';
export const GET_PRODUCTS_SUCCESS = 'takeback/api/PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE = 'takeback/api/PRODUCTS_FAILURE';

const initialState = Immutable.Map();

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GET_PRODUCTS_SUCCESS:
            return action.products.reduce((map, product) => {
                return map.set(product.get('id'), product);
            }, Immutable.Map());
        default:
            return state;
    }
}

// Actions
export function getProducts(params) {
    return {type: GET_PRODUCTS, params};
}

export function getProductsSuccess(products) {
    return {type: GET_PRODUCTS_SUCCESS, products};
}

export function getProductsFailure(error) {
    return {type: GET_PRODUCTS_FAILURE, error};
}
